module.exports = __webpack_public_path__ + "static/media/undraw_update_uxn2.2735930c.svg";